import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Result, Typography } from "antd";

const { Paragraph, Text } = Typography;

export const MercadoPagoErroCallbackInfo = ({ params, rebillError }) => {
  return (
    <Result
      status="warning"
      title="Ups..."
      subTitle={`Al parecer hubo algún inconveniente${rebillError ? "" : " en Mercado Pago"}, por favor intente nuevamente más tarde.`}
    >
      {((params.error || params.errorDescription) && !rebillError) ? (
        <div className="desc">
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 16,
              }}
            >
              {" "}
              Mercado Pago nos informa:
            </Text>
          </Paragraph>
          {params.error ? (
            <Paragraph>
              <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
              Error: {params.error}
            </Paragraph>
          ) : null}
          {params.errorDescription ? (
            <Paragraph>
              <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
              Descripción: {params.errorDescription}
            </Paragraph>
          ) : null}
        </div>
      ) : null}
    </Result>
  )
}